module.exports = __webpack_public_path__ + "static/4-cfb70686399953ac64cf8b6e361e688c.jpg";